export default "__VITE_ASSET__9e7c2f44__"